/** Flatten permission-filtered sidebar menu into searchable header links. */
export function flattenMenuLinks(menu = []) {
  const items = [];

  const visit = (node, parentIcon) => {
    if (!node) {
      return;
    }
    const icon = node.icon || parentIcon;
    if (node.type === "link" && node.path) {
      items.push({
        title: node.title,
        path: node.path,
        icon: icon || "home",
      });
    }
    (node.children || []).forEach((child) => visit(child, icon));
  };

  menu.forEach((group) => {
    (group.Items || []).forEach((section) => visit(section, section.icon));
  });

  return items;
}

export function searchMenuLinks(menu, keyword) {
  const query = String(keyword || "").trim().toLowerCase();
  if (!query) {
    return [];
  }
  return flattenMenuLinks(menu).filter((item) => item.title.toLowerCase().includes(query));
}
